import { useConfig } from '../contexts/ConfigContext';

/**
 * Hook that returns whether the site banner is currently visible.
 * Layouts use this to add top padding/offset when the banner is shown.
 */
// eslint-disable-next-line react-refresh/only-export-components
export function useBannerShown(): boolean {
  const { config } = useConfig();
  return !!config.banner_enabled && !!config.banner_text;
}

export function EnvironmentBanner() {
  const { config } = useConfig();

  if (!config.banner_enabled || !config.banner_text) {
    return null;
  }

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] text-center py-1 px-4 text-sm font-semibold"
      style={{
        backgroundColor: config.banner_bg_color || '#facc15',
        color: config.banner_text_color || '#1a1a00',
      }}
    >
      {config.banner_text}
    </div>
  );
}
